const CustomerIdType = ['Carte Nationale d\'Identite(CNI)', 'Permis de conduire', 'Passeport', 'Attestation d\'identité', 'Carte consulaire']
export default CustomerIdType